import { hasTauriRuntime } from './environment'

type UnlistenFn = () => void

export type DesktopUpdaterAvailablePayload = {
  version?: string
}

async function getInvoke() {
  if (!hasTauriRuntime()) {
    return null
  }
  const module = await import('@tauri-apps/api/core')
  return module.invoke
}

async function getListen() {
  if (!hasTauriRuntime()) {
    return null
  }
  const module = await import('@tauri-apps/api/event')
  return module.listen
}

export async function installDesktopUpdate() {
  const invoke = await getInvoke()
  if (!invoke) {
    return false
  }
  await invoke('install_update')
  return true
}

export async function onDesktopUpdateAvailable(
  callback: (payload: DesktopUpdaterAvailablePayload) => void,
): Promise<UnlistenFn | null> {
  const listen = await getListen()
  if (!listen) {
    return null
  }
  return listen<DesktopUpdaterAvailablePayload>('updater:available', (event) => {
    callback(event.payload || {})
  })
}
